<div class="container-fluid admin-form-page">
  <app-content-tab-list activeTab="0" type="management" category="Management"></app-content-tab-list>
  <section class="mb-5 mt-4">
    <div class="row">
      <div class="col-12 col-md-7 col-lg-7 col-xl-7">
        <div class="home-details">
          <h5 class="home-title">Super Categories</h5>
          <p class="home-subtitle">List of all Super Categories</p>
        </div>
      </div>
      <div class="col-12 col-md-7 col-lg-5 col-xl-5">
        <div class="dashboard-btn dashboard-manage admin-page-actions">
          <button class="btn btn-primary btn-dashboard" (click)="openModal(superCatModal, false)">
            <i class="las la-plus"></i>Create Super Category
          </button>
        </div>
      </div>
    </div>
    <div class="table-responsive applicants-details mt-4 overflow-x-visible admin-form-card">
      <table class="table table-bordered user-table">
        <thead>
          <tr>
            <th scope="col">ID</th>
            <th scope="col">Super Category Name</th>
            <th scope="col">Categories</th>
            <th scope="col">Created At</th>
            <th scope="col">Actions</th>
          </tr>
        </thead>
        @if (!loading && !!superCategories?.length) {
          <tbody>
            @for (sp of superCategories; track sp; let i = $index) {
              <tr class="client">
                <td class="text-nowrap" [attr.title]="(sp.id || '').toUpperCase()"><span>{{(sp.id || '').slice(-6).toUpperCase()}}</span>
                <i (click)="handleCopyToClipboard(sp.id);" class="las la-copy la-lg pointer copy-icon"></i>
              </td>
              <td>{{sp.categoryName}}</td>
              <td>@for (spc of sp.categories; track spc) {
                <span>{{spc.categoryName}}, </span>
              }</td>
              <td>{{sp.createdAt | date: 'medium'}}</td>
              <td class="action">
                <div class="dropdown">
                  <button type="button" class="btn header-item waves-effect btn-dropdown" id="page-header-user-dropdown"
                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                    <a class="   mr-3 text-primary py-2 text-nowrap">
                      View actions <i class="las mb-1 la-angle-down align-middle mr-0"></i></a>
                    </button>
                    <div class="dropdown-menu dropdown-menu-right animate slideIn side-menu-dropdown py-0 rounded-1">
                      <a class=" dropdown-item  text-info border-bottom py-2 text-nowrap"
                        (click)="startEditMode(sp.id, sp.categoryName, sp.categories, superCatModal)">
                        <i class="las la-edit mb-1 la-lg  align-middle mr-0"></i> Edit</a>
                      </div>
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          }
          @if (loading) {
            <tbody>
              @for (q of loaders; track q; let qi = $index) {
                <tr class="client">
                  <td>
                    <ngx-skeleton-loader [theme]="{width:'150px', marginBottom: '0px'}"></ngx-skeleton-loader>
                  </td>
                  <td>
                    <ngx-skeleton-loader [theme]="{ width:'200px', marginBottom: '0px'}"></ngx-skeleton-loader>
                  </td>
                  <td>
                    <ngx-skeleton-loader [theme]="{width:'500px', marginBottom: '0px'}"></ngx-skeleton-loader>
                  </td>
                  <td>
                    <ngx-skeleton-loader [theme]="{width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader>
                  </td>
                  <td>
                    <ngx-skeleton-loader [theme]="{width:'100px', marginBottom: '0px'}"></ngx-skeleton-loader>
                  </td>
                </tr>
              }
            </tbody>
          }
        </table>
        @if (!loading && !superCategories?.length) {
          <div class="d-flex align-items-center justify-content-center py-5">
            No categories found
          </div>
        }
      </div>
    </section>
  </div>

  <ng-template #superCatModal>
    <form class="admin-form" (ngSubmit)="editMode ? updateSuperCategory() : addSuperCat()" ngNativeValidate>
      <div class="modal-header">
        @if (!editMode) {
          <h5 class="modal-title">Add Super Category</h5>
        }
        @if (editMode) {
          <h5 class="modal-title">Update Super Category</h5>
        }
        <button type="button" class="close " data-dismiss="modal" aria-label="Close" (click)="modalRef.hide();">
          <span aria-hidden="true" class="">&times;</span>
        </button>
      </div>
      <div class="mx-2 modal-body user-form">
        <div class="form-group">
          <label>Super Category Name</label>
          <input placeholder='Enter Name' class=" form-control" [(ngModel)]="superCat.superCatName" name="superCatName"
            required>
        </div>

        <div class="form-group">
          <label>Categories</label>
          <div class="row mx-0">
            @for (c of categories; track c; let i = $index) {
              <section class="col-6">
                @if (editMode) {
                  <input type="checkbox"
                    [id]="'edit_category' + i"
                    [value]="c.id" [checked]="superCat.categories.includes(c.id)" class="mr-2"
                    (change)="superChildChange($event, c.id, c.className)">
                }
                @if (!editMode) {
                  <input
                    type="checkbox" [value]="c.id" class="mr-2"
                    [id]="'add_category' + i"
                    (change)="superChildChange($event, c.id, c.className)">
                }
                <label [htmlFor]="editMode ? 'edit_category' + i : 'add_category' + i" class="mr-2 pointer" >{{c.className}}</label>
              </section>
            }
          </div>
        </div>

      </div>
      <div class="modal-footer justify-content-end">
        <button type="button" class="btn btn-light" (click)="modalRef.hide();">Close</button>
        <button [disabled]="superCat.superCatName.length == 0 || superCat.categories.length == 0"
        class="btn btn-primary btn-dashboard" type="submit"> {{editMode ? 'Update' : 'Add'}}</button>
      </div>
    </form>
  </ng-template>
